import React from 'react';
import * as styles from './agent-profile-agency-banner.style';
import isDarkColour from '../../utils/is-dark-colour';

export type AgentProfileAgencyBannerProps = {
  agencyName: string;
  agencyUrl: string;
  address: string;
  suburb: string;
  logoUrl?: string | null;
  brandColour?: string | null;
};

const AgentProfileAgencyBanner = ({
  agencyName,
  agencyUrl,
  address,
  suburb,
  logoUrl,
  brandColour,
}: AgentProfileAgencyBannerProps): JSX.Element => {
  const isDarkBackground = isDarkColour(brandColour);

  return (
    <section
      aria-label={`${agencyName} agency`}
      css={styles.banner({
        brandColour: brandColour || undefined,
        isDarkBackground,
      })}
      data-testid="agent-profile-agency-banner"
    >
      {logoUrl && (
        <a
          aria-label={`View ${agencyName} profile`}
          css={styles.logoLink}
          data-testid="agent-profile-agency-banner-logo-link"
          href={agencyUrl}
        >
          <img alt={agencyName} css={styles.logo} src={logoUrl} />
        </a>
      )}
      {logoUrl && (
        <>
          <p css={[styles.address, styles.desktopAddress]}>{address}</p>
          <p css={[styles.address, styles.mobileAddress]}>{suburb}</p>
        </>
      )}
    </section>
  );
};

export default AgentProfileAgencyBanner;
